import { Variable, variablesToFieldsInfo } from '@microservices/wiskey-react-components'

import { BIND_TYPE } from '@constants'
import { AutocompleteOption, MainObjectTypeEnum, ObjectFieldDTO } from '@types'

const mapObjectFieldsToVariables = (fields: ObjectFieldDTO[]): Variable[] =>
  fields.map(
    field =>
      ({
        name: field.name,
        type: field.valueType,
        description: field.desc,
      }) as Variable
  )

export const getMainObjectGroupTitleScriptConfig = (data: {
  watchMainObjectType: MainObjectTypeEnum
  watchObjectXObject?: AutocompleteOption
  watchObjectYObject?: AutocompleteOption
  objectXFields: ObjectFieldDTO[]
  objectYFields: ObjectFieldDTO[]
}) => {
  const {
    watchMainObjectType,
    watchObjectXObject,
    watchObjectYObject,
    objectXFields,
    objectYFields,
  } = data

  const groupMetaFields =
    watchMainObjectType === MainObjectTypeEnum.X ? objectXFields : objectYFields

  const variables: Variable[] = [
    {
      name: 'srcObj',
      type: [
        { name: 'groupKey', type: 'string', description: 'Grouping key' },
        {
          name: 'groupData',
          type: 'array',
          description: 'Grouped timeline rows for the interval',
        },
        {
          name: 'groupMeta',
          type: !groupMetaFields?.length
            ? 'any'
            : mapObjectFieldsToVariables(groupMetaFields),
          description:
            watchMainObjectType === MainObjectTypeEnum.X
              ? watchObjectXObject?.label || 'Object X'
              : watchObjectYObject?.label || 'Object Y',
        },
        {
          name: 'displayField',
          type: 'string',
          description: 'Value resolved from Display Field',
        },
      ],
    },
  ]

  return {
    variables,
    fieldsInfo: variablesToFieldsInfo(variables),
    examples: [
      {
        title: 'Display field (JS)',
        description: 'Returns the configured display field value.',
        code: 'return srcObj.displayField',
      },
      {
        title: 'Group key (JS)',
        description: 'Returns the grouping key.',
        code: 'return srcObj.groupKey',
      },
      {
        title: 'Styled title (JSX)',
        description: 'Renders display field with basic styling.',
        code:
          "<div style={{ padding: '4px 8px', fontWeight: 600 }}>\n" +
          '  {srcObj.displayField}\n' +
          '</div>',
      },
      {
        title: 'Group key with count (JSX)',
        description: 'Shows group key and number of rows in the group.',
        code:
          '<div>\n' +
          '  <span>{srcObj.groupKey}</span>\n' +
          '  <span style={{ marginLeft: 8, opacity: 0.7 }}>({srcObj.groupData?.length ?? 0})</span>\n' +
          '</div>',
      },
    ],
  }
}

export const getMainObjectGroupTitleScriptLanguage = (
  groupTitleTypeId?: string
): 'js' | 'jsx' =>
  groupTitleTypeId === BIND_TYPE.JSX || groupTitleTypeId === 'JSX' ? 'jsx' : 'js'
